import { TsConfig } from "../API/TsConfig";
import { isAuthoring } from "../StaticConfig";
import { TableauLocalizedStrings } from "../Strings";

export function updateDocumentTitle(
  doc: Document,
  strings: TableauLocalizedStrings,
  tsConfig: TsConfig
) {
  doc.title = isAuthoring(doc)
    ? strings.AuthoringWorkbookTitle(tsConfig.workbookName)
    : strings.EmbeddedWorkbookTitle(tsConfig.workbookName);
}
